import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/components/home/home'
import Skill from '@/components/skill/skill'
import Product from '@/components/product/product'
import Serve from '@/components/serve/serve'
import Solve from '@/components/solve/solve'
import Client from '@/components/client/client'
import About from '@/components/about/about'
import News from '@/components/news/news'
import Publish from '@/components/news/publish/publish'
import Contest from '@/components/news/contest/contest'
import Training from '@/components/news/training/training'
import Book from '@/components/news/book/book'
import Coming from '@/components/news/coming/coming'
import Fruit from '@/components/news/fruit/fruit'
import Invest from '@/components/news/invest/invest'
import Scientist from '@/components/news/scientist/scientist'
import Numbers from '@/components/news/numbers/numbers'
import Light from '@/components/news/light/light'
import Pythons from '@/components/solve/pythons/pythons'
import Police from '@/components/solve/police/police'
import Torter from '@/components/solve/torter/torter'
import Sanne from '@/components/solve/sanne/sanne'
import Text from '@/components/solve/text/text'


Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home,
    },
    {
      name: 'skill',
      path: '/skill',
      component: Skill
    },
    {
      name: 'product',
      path: '/product',
      component: Product
    },
    {
      name: 'serve',
      path: '/serve',
      component: Serve
    },
    {
      name: 'solve',
      path: '/solve',
      component: Solve
    },
    {
      name: 'client',
      path: '/client',
      component: Client
    },
    {
      name: 'about',
      path: '/about',
      component: About
    },
    {
      name: 'news',
      path: '/news',
      component: News
    },
    // 新闻中心内部路由
    {
      name: 'publish',
      path: '/publish',
      component: Publish
    },    
    {
      name: 'contest',
      path: '/contest',
      component: Contest
    },  
    {
      name: 'training',
      path: '/training',
      component: Training
    },
    {
      name: 'book',
      path: '/book',
      component: Book
    },
    {
      name: 'coming',
      path: '/coming',
      component: Coming
    },
    {
      name: 'fruit',
      path: '/fruit',
      component: Fruit
    },
    {
      name: 'invest',
      path: '/invest',
      component: Invest
    },
    {
      name: 'scientist',
      path: '/scientist',
      component: Scientist
    },
    {
      name: 'numbers',
      path: '/numbers',
      component: Numbers
    },
    {
      name: 'pythons',
      path: '/pythons',
      component: Pythons
    },
    {
      name: 'police',
      path: '/police',
      component: Police
    },
    {
      name: 'torter',
      path: '/torter',
      component: Torter
    },
    {
      name: 'sanne',
      path: '/sanne',
      component: Sanne
    },
    {
      name: 'text',
      path: '/text',
      component: Text
    },
    {
      name: 'light',
      path: '/light',
      component: Light
    }
    
    
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js